import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_NODE_API;

export const fetchWorkerChildCareFacilities = createAsyncThunk(
  "workerChildCareFacilities/fetch",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const params = {
        rm: 'Search',
        search_keywords_name: filters.search_keywords_name || "",
        search_exact_fips: filters.search_exact_fips || "",
        search_contains_zip: filters.search_contains_zip || "",
      };

      // Add checkbox selections only if user selected some
      if (filters.selectedTypes && filters.selectedTypes.length > 0) {
        params.selectedTypes = filters.selectedTypes.join(','); // comma-separated for API
      }

      if (filters.search_modifiers_mod_cde) {
        params.search_modifiers_mod_cde = 1;
      }

      const res = await axios.get(`${BACKEND_URL}/child-care/facilities`, {
        params
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchWorkerChildCareFacilityDetails = createAsyncThunk(
  "workerChildCareFacilityDetails/fetch",
  async (facilityLink, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BACKEND_URL}/child-care/facility-details`, {
        params: {
          path: facilityLink
        }
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchWorkerChildCareFacilitiesInit = createAsyncThunk(
  "workerChildCareFacilitiesInit/fetch",
  async (_, { rejectWithValue }) => {
    try {

      const res = await axios.get(`${BACKEND_URL}/child-care/facilities`, {
        rm: 'Search',
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


const workerChildCareFacilitiesSlice = createSlice({
    name: 'workerChildCareFacilities',
    initialState: {
    loading: false,
    error: null,
    initLoading: false,
    initError: null,
    childCareFacilitiesData: [],
    childCareFacilityDetails: [],
    childCareFacilitiesDataInit: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkerChildCareFacilities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkerChildCareFacilities.fulfilled, (state, action) => {
        state.loading = false;
        state.childCareFacilitiesData = action.payload;
      })
      .addCase(fetchWorkerChildCareFacilities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch child care facilities data';
      })
      .addCase(fetchWorkerChildCareFacilityDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkerChildCareFacilityDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.childCareFacilityDetails = action.payload;
      })
      .addCase(fetchWorkerChildCareFacilityDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch child care facilities data';
      })
      .addCase(fetchWorkerChildCareFacilitiesInit.pending, (state) => {
        state.initLoading = true;
        state.initError = null;
      })
      .addCase(fetchWorkerChildCareFacilitiesInit.fulfilled, (state, action) => {
        state.initLoading = false;
        state.childCareFacilitiesDataInit = action.payload;
      })
      .addCase(fetchWorkerChildCareFacilitiesInit.rejected, (state, action) => {
        state.initLoading = false;
        state.initError = action.payload || 'Failed to fetch child care facilities data';
      })
  },
    });

export default workerChildCareFacilitiesSlice.reducer;